export const ATUALIZADO = 'Desconto atualizado'
export const CADASTRADO = 'Desconto adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados descontos cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há descontos com esse filtro'
